import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "viewer-toggle__icon-circle" }
const _hoisted_2 = { class: "viewer-toggle__text" }
const _hoisted_3 = { class: "viewer-toggle__value" }
const _hoisted_4 = {
  key: 0,
  class: "viewer-dropdown"
}
const _hoisted_5 = { class: "viewer-dropdown__header" }
const _hoisted_6 = { class: "viewer-dropdown__search" }
const _hoisted_7 = { class: "viewer-option__avatar viewer-option__avatar--all" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "viewer-option__avatar" }
const _hoisted_10 = { class: "viewer-option__text" }
const _hoisted_11 = { class: "viewer-option__name" }
const _hoisted_12 = { class: "viewer-option__subtitle" }

import { computed, ref, watch, nextTick, onMounted, onBeforeUnmount } from "vue";
import { Icon } from "@/components/ui";
import { getRoleDisplayName } from "@/utils/enums";


export default /*@__PURE__*/_defineComponent({
  __name: 'OwnerFilterPicker',
  props: {
    modelValue: { default: "all" },
    users: { default: () => [] },
    showAllOption: { type: Boolean, default: true }
  },
  emits: ["update:modelValue", "select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const rootRef = ref<HTMLElement | null>(null);
const searchInputRef = ref<HTMLInputElement | null>(null);
const isDropdownOpen = ref(false);
const searchQuery = ref("");

const filteredUsers = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  if (!q) return props.users;
  return props.users.filter((u) => u.fullName?.toLowerCase().includes(q));
});

const selectedOwnerKey = computed(() => {
  if (props.modelValue === "all" || props.modelValue == null || props.modelValue === "")
    return "all";
  return props.modelValue;
});

const currentOwnerLabel = computed(() => {
  if (selectedOwnerKey.value === "all") return "All Users";
  const user = props.users?.find((u) => u.id === selectedOwnerKey.value);
  return user?.fullName || "All Users";
});

const handleSelectAll = () => {
  isDropdownOpen.value = false;
  searchQuery.value = "";
  emit("update:modelValue", "all");
  emit("select", "all");
};

const handleSelectUser = (user: { id: string; fullName?: string; role?: string }) => {
  isDropdownOpen.value = false;
  searchQuery.value = "";
  emit("update:modelValue", user.id);
  emit("select", user);
};

const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
  if (!isDropdownOpen.value) searchQuery.value = "";
};

watch(isDropdownOpen, (open) => {
  if (open) {
    nextTick(() => searchInputRef.value?.focus());
  }
});

const handleClickOutside = (event: MouseEvent) => {
  if (!isDropdownOpen.value) return;
  if (rootRef.value && !rootRef.value.contains(event.target as Node)) {
    isDropdownOpen.value = false;
    searchQuery.value = "";
  }
};

const getInitials = (fullName?: string) => {
  if (!fullName) return "";
  const parts = fullName.trim().split(/\s+/);
  const initials = parts.slice(0, 2).map((p) => p[0]?.toUpperCase() || "");
  return initials.join("");
};

const getRoleLabel = (role?: string) => {
  if (!role) return "";
  return getRoleDisplayName(role);
};

onMounted(() => {
  document.addEventListener("click", handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "owner-filter-picker",
    ref_key: "rootRef",
    ref: rootRef,
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "viewer-toggle",
      onClick: toggleDropdown
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(Icon), {
          icon: "majesticons:users-line",
          class: "viewer-toggle__icon"
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "viewer-toggle__label" }, "Viewing:", -1)),
        _createElementVNode("span", _hoisted_3, _toDisplayString(currentOwnerLabel.value), 1)
      ]),
      _createVNode(_unref(Icon), {
        icon: isDropdownOpen.value ? 'mdi:chevron-up' : 'mdi:chevron-down',
        class: "viewer-toggle__chevron"
      }, null, 8, ["icon"])
    ]),
    (isDropdownOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(Icon), {
              icon: "uil:user",
              class: "viewer-dropdown__header-icon"
            }),
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "viewer-dropdown__header-text" }, "Select user to view their data", -1))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(Icon), {
              icon: "mdi:magnify",
              class: "viewer-dropdown__search-icon"
            }),
            _withDirectives(_createElementVNode("input", {
              ref_key: "searchInputRef",
              ref: searchInputRef,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
              type: "text",
              class: "viewer-dropdown__search-input",
              placeholder: "Search users...",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, null, 512), [
              [_vModelText, searchQuery.value]
            ])
          ]),
          (__props.showAllOption && filteredUsers.value.length === __props.users.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: _normalizeClass(["viewer-option", { 'viewer-option--selected': selectedOwnerKey.value === 'all' }]),
                onClick: handleSelectAll
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(Icon), {
                    icon: "majesticons:users-line",
                    class: "viewer-option__avatar-icon"
                  })
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "viewer-option__text" }, [
                  _createElementVNode("span", { class: "viewer-option__name" }, "All Users"),
                  _createElementVNode("span", { class: "viewer-option__subtitle" }, "View combined data")
                ], -1)),
                (selectedOwnerKey.value === 'all')
                  ? (_openBlock(), _createBlock(_unref(Icon), {
                      key: 0,
                      icon: "mdi:check",
                      class: "viewer-option__check-icon"
                    }))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUsers.value, (user) => {
            return (_openBlock(), _createElementBlock("button", {
              key: user.id,
              type: "button",
              class: _normalizeClass(["viewer-option", { 'viewer-option--selected': selectedOwnerKey.value === user.id }]),
              onClick: ($event: any) => (handleSelectUser(user))
            }, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(getInitials(user.fullName)), 1),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(user.fullName), 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(getRoleLabel(user.role)), 1)
              ]),
              (selectedOwnerKey.value === user.id)
                ? (_openBlock(), _createBlock(_unref(Icon), {
                    key: 0,
                    icon: "mdi:check",
                    class: "viewer-option__check-icon"
                  }))
                : _createCommentVNode("", true)
            ], 10, _hoisted_8))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})